// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
	apiKey: "AIzaSyBJGzl5LXbqIW83P_5VxU6_bVeKltPGid4",
	authDomain: "doc-service-949fd.firebaseapp.com",
	projectId: "doc-service-949fd",
	storageBucket: "doc-service-949fd.appspot.com",
	messagingSenderId: "490273371293",
	appId: "1:490273371293:web:9ed740f77ceca0d4869074",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;